import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import OffersPopup from '../components/common/OffersPopup';
import api from '../utils/api';

export default function Home() {
  const { user } = useAuth();
  const [platforms, setPlatforms] = useState([]);
  const [stats, setStats] = useState({ platforms: 0, offers: 0, members: 0 });

  useEffect(() => {
    api.get('/platforms').then(({ data }) => {
      setPlatforms(data.platforms?.slice(0, 6) || []);
      setStats(s => ({ ...s, platforms: data.platforms?.length || 0 }));
    });
    api.get('/offers').then(({ data }) => setStats(s => ({ ...s, offers: data.offers?.length || 0 })));
  }, []);

  const heroStyle = {
    minHeight: '100vh',
    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    textAlign: 'center', padding: '100px 20px 60px',
    background: 'radial-gradient(ellipse at 50% 0%, rgba(245,196,0,0.07) 0%, transparent 70%), var(--bg-primary)',
    position: 'relative', overflow: 'hidden',
  };

  return (
    <div>
      {user && <OffersPopup />}

      {/* Hero */}
      <section style={heroStyle}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)', backgroundSize: '60px 60px', opacity: 0.2 }} />
        <div style={{ position: 'relative', zIndex: 1, maxWidth: 800, margin: '0 auto' }}>
          <div style={{ display: 'inline-block', background: 'rgba(245,196,0,0.1)', border: '1px solid rgba(245,196,0,0.3)', borderRadius: 20, padding: '6px 18px', fontSize: 13, color: 'var(--accent-cyan)', marginBottom: 24, fontWeight: 700, letterSpacing: '0.1em' }}>
            🎮 PREMIUM GAMING PLATFORM
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px,7vw,80px)', lineHeight: 1.1, marginBottom: 24 }}>
            <span style={{ background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>APEX</span>
            <br />
            <span style={{ color: 'var(--text-primary)' }}>GAMING</span>
          </h1>
          <p style={{ fontSize: 'clamp(16px,2.5vw,22px)', color: 'var(--text-secondary)', marginBottom: 40, maxWidth: 600, margin: '0 auto 40px' }}>
            Access the best gaming platforms, claim exclusive daily offers, and join a thriving gaming community.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/platforms" className="btn btn-primary" style={{ fontSize: 16, padding: '14px 36px' }}>Explore Platforms</Link>
            <Link to="/offers" className="btn btn-secondary" style={{ fontSize: 16, padding: '14px 36px' }}>Daily Offers</Link>
          </div>
        </div>
        <div style={{ position: 'absolute', top: '20%', left: '5%', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(245,196,0,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '10%', right: '5%', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(201,160,0,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
      </section>

      {/* Stats */}
      <section style={{ padding: '40px 0', background: 'var(--bg-secondary)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px,1fr))', gap: 20, textAlign: 'center' }}>
            {[
              { label: 'Gaming Platforms', value: `${stats.platforms}+`, icon: '🎮' },
              { label: 'Daily Offers',     value: `${stats.offers}+`,    icon: '🎁' },
              { label: 'Active Members',   value: '10K+',                icon: '👥' },
              { label: 'Daily Rewards',    value: '$50K+',               icon: '💰' },
            ].map(s => (
              <div key={s.label}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>{s.icon}</div>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 900, background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{s.value}</div>
                <div style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Platforms */}
      {platforms.length > 0 && (
        <section style={{ padding: '80px 0' }}>
          <div className="container">
            <div style={{ textAlign: 'center', marginBottom: 48 }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,4vw,40px)', background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>FEATURED PLATFORMS</h2>
              <p style={{ color: 'var(--text-secondary)', marginTop: 10, fontSize: 18 }}>Top gaming platforms at your fingertips</p>
            </div>
            <div className="grid-3">
              {platforms.map(p => (
                <div key={p._id} className="card" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ width: 50, height: 50, background: 'var(--gradient-primary)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: 20, color: '#0a0900' }}>{p.name[0]}</div>
                    {p.isHottest && <span className="badge badge-hot">🔥 HOTTEST</span>}
                    {p.label && !p.isHottest && <span className={`badge badge-${p.label.toLowerCase()}`}>{p.label}</span>}
                  </div>
                  <div>
                    <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 18, marginBottom: 6 }}>{p.name}</h3>
                    {p.description && <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{p.description}</p>}
                  </div>
                  <a href={p.downloadUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm" style={{ alignSelf: 'flex-start' }}>Download ↗</a>
                </div>
              ))}
            </div>
            <div style={{ textAlign: 'center', marginTop: 40 }}>
              <Link to="/platforms" className="btn btn-secondary" style={{ fontSize: 16, padding: '12px 32px' }}>View All Platforms →</Link>
            </div>
          </div>
        </section>
      )}

      {/* Features */}
      <section style={{ padding: '80px 0', background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,4vw,40px)', color: 'var(--text-primary)' }}>WHY APEX GAMING?</h2>
          </div>
          <div className="grid-4">
            {[
              { icon: '🛡️', title: 'Secure & Safe',  desc: 'All platforms verified and trusted by thousands of players.' },
              { icon: '⚡',  title: 'Daily Offers',   desc: 'New exclusive offers and bonuses updated every single day.' },
              { icon: '🎮', title: 'Mini Games',      desc: 'Play fun mini-games including slots, quiz, keno and more.' },
              { icon: '💎', title: 'Memberships',     desc: 'Unlock premium perks with weekly, monthly or yearly plans.' },
            ].map(f => (
              <div key={f.title} className="card" style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>{f.icon}</div>
                <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 16, marginBottom: 10, color: 'var(--accent-cyan)' }}>{f.title}</h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Wheel of Fortune CTA */}
      <section style={{ padding: '60px 0', background: 'linear-gradient(135deg, rgba(245,196,0,0.08) 0%, rgba(201,160,0,0.04) 100%)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <div style={{ display: 'flex', alignItems: 'center', gap: 40, maxWidth: 800, margin: '0 auto', flexWrap: 'wrap', justifyContent: 'center', textAlign: 'center' }}>
            <div style={{ fontSize: 80 }}>🎡</div>
            <div style={{ flex: 1, minWidth: 260 }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(22px,4vw,36px)', color: '#f5c400', marginBottom: 10 }}>DAILY WHEEL SPIN</h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: 16, marginBottom: 20, lineHeight: 1.6 }}>
                Spin the Wheel of Fortune every day for FREE! Win Fun Credits, Freeplay bonuses and more — no deposit required!
              </p>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link to="/wheel" className="btn btn-primary" style={{ fontSize: 15, padding: '12px 28px' }}>🎡 Spin Now — It's Free!</Link>
                <Link to="/games" className="btn btn-secondary" style={{ fontSize: 15, padding: '12px 28px' }}>🎰 Mini Games</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Join Our Community */}
      <section style={{ padding: '80px 0' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,4vw,40px)', background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              JOIN OUR COMMUNITY
            </h2>
            <p style={{ color: 'var(--text-secondary)', marginTop: 10, fontSize: 18 }}>
              Follow us for exclusive offers, updates and giveaways
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20, maxWidth: 900, margin: '0 auto' }}>

            {/* Facebook */}
            <a href="https://www.facebook.com/OfficialApex77" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <div
                style={{ background: 'linear-gradient(135deg, #1877F2 0%, #0d5ec9 100%)', borderRadius: 16, padding: '28px 24px', display: 'flex', alignItems: 'center', gap: 18, cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s', boxShadow: '0 4px 20px rgba(24,119,242,0.25)' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(24,119,242,0.5)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(24,119,242,0.25)'; }}
              >
                <div style={{ width: 56, height: 56, background: 'rgba(255,255,255,0.15)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </div>
                <div>
                  <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12, fontWeight: 600, letterSpacing: '0.08em', marginBottom: 4 }}>FACEBOOK PAGE</div>
                  <div style={{ color: '#fff', fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700 }}>OfficialApex77</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 4 }}>Like and follow our page →</div>
                </div>
              </div>
            </a>

            {/* Telegram */}
            <a href="https://t.me/OfficialApex77" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <div
                style={{ background: 'linear-gradient(135deg, #0088cc 0%, #006aaa 100%)', borderRadius: 16, padding: '28px 24px', display: 'flex', alignItems: 'center', gap: 18, cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s', boxShadow: '0 4px 20px rgba(0,136,204,0.25)' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,136,204,0.5)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,136,204,0.25)'; }}
              >
                <div style={{ width: 56, height: 56, background: 'rgba(255,255,255,0.15)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                  </svg>
                </div>
                <div>
                  <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12, fontWeight: 600, letterSpacing: '0.08em', marginBottom: 4 }}>TELEGRAM CHANNEL</div>
                  <div style={{ color: '#fff', fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700 }}>OfficialApex77</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 4 }}>Join our channel →</div>
                </div>
              </div>
            </a>

            {/* Instagram */}
            <a href="https://www.instagram.com/officialapexgaming7" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <div
                style={{ background: 'linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)', borderRadius: 16, padding: '28px 24px', display: 'flex', alignItems: 'center', gap: 18, cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s', boxShadow: '0 4px 20px rgba(220,39,67,0.25)' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(220,39,67,0.5)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(220,39,67,0.25)'; }}
              >
                <div style={{ width: 56, height: 56, background: 'rgba(255,255,255,0.15)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
                  </svg>
                </div>
                <div>
                  <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12, fontWeight: 600, letterSpacing: '0.08em', marginBottom: 4 }}>INSTAGRAM</div>
                  <div style={{ color: '#fff', fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700 }}>officialapexgaming7</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 4 }}>Follow us on Instagram →</div>
                </div>
              </div>
            </a>

          </div>
        </div>
      </section>

      {/* CTA */}
      {!user && (
        <section style={{ padding: '80px 0', textAlign: 'center', background: 'var(--bg-secondary)' }}>
          <div className="container">
            <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-glow)', borderRadius: 20, padding: '60px 40px', boxShadow: 'var(--shadow-glow)', maxWidth: 700, margin: '0 auto' }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,4vw,40px)', marginBottom: 16, color: 'var(--text-primary)' }}>JOIN APEX GAMING</h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: 18, marginBottom: 32 }}>Create your free account and unlock exclusive offers, memberships, and more.</p>
              <Link to="/register" className="btn btn-primary" style={{ fontSize: 18, padding: '14px 48px' }}>Get Started Free →</Link>
            </div>
          </div>
        </section>
      )}

    </div>
  );
}
